module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      'expanded': _vm.headerExpanded
    }
  }, [_c('div', {
    staticClass: "mobile-nav-click",
    on: {
      "click": function($event) {
        _vm.headerExpanded = !_vm.headerExpanded
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav-menu",
    domProps: {
      "innerHTML": _vm._s(_vm.headerExpanded ? 'Close' : 'Menu')
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "https://hatopress.net"
    }
  }, [_vm._v("\n        Hato Press\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('a', {
    attrs: {
      "href": "https://hatopress.net/printing"
    }
  }, [_vm._v("Printing")]), _vm._v(" "), _c('a', [_vm._v("Workshops")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://shop.hatopress.net"
    }
  }, [_vm._v("Shop")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://hatopress.net/news"
    }
  }, [_vm._v("Journal")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://hatopress.net/about/"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://hatopress.net/contact/"
    }
  }, [_vm._v("Contact")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fac6c1e6","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMain.vue
// module id = 227
// module chunks = 1